import { Injectable, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IRequestCallback } from '@df/api/request/request.service';
import { Status } from '@df/core/status';
import { NewsletterService } from '@df/session/newsletter/newsletter.service';
import { Newsletter } from '@df/session/newsletter/newsletter.interfaces';
import { AntavoService } from '../module/antavo/antavo.service';
import { LocalCustomerModel } from '../customer/customer.model.decorator';
import compact from 'lodash-es/compact';
import flatten from 'lodash-es/flatten';

/**
 * Local decorator for NewsletterService that sends Antavo custom events
 */
@Injectable({
    providedIn: 'root'
})
export class LocalNewsletterService extends NewsletterService {
    private antavoService = inject(AntavoService);
    private customerModel = inject(LocalCustomerModel);

    /**
     * Subscribes by email or customer id and sends Antavo newsletter_subscription event
     */
    override subscribe(
        form: NgForm | undefined,
        status: Status | undefined,
        data: Newsletter.ISubscribeRequest,
        onSuccess?: IRequestCallback,
        onError?: IRequestCallback
    ): Promise<Newsletter.IResponse> | void {
        // Create Antavo event callback
        const antavoEventCallback = async () => {
            try {
                if (this.customerModel.loyaltyId) {
                    await this.antavoService.sendCustomEvent(
                        {
                            loyaltyId: this.customerModel.loyaltyId,
                            action: 'newsletter_subscription',
                            data: {
                                email: data.email
                            }
                        },
                        new Status()
                    );
                }
            } catch (error) {
                console.warn('Failed to send Antavo newsletter subscription event:', error);
                // Don't fail the newsletter subscription if Antavo event fails
            }
        };

        // Combine original success callbacks with Antavo event callback
        const enhancedOnSuccess = compact(flatten([onSuccess, antavoEventCallback]));

        // Call parent subscribe method with enhanced success callback
        return super.subscribe(form, status, data, enhancedOnSuccess, onError);
    }
}
